import axios from "axios";

axios.interceptors.request.use(function (config) {
  const cookieString = document.cookie;
  const cookies = cookieString.split(";");

  let token = null;
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith("principally=")) {
      token = cookie.substring(12);
    }
  }

  if (config.headers) {
    config.headers.Authorization = "Bearer " + (!token ? "logged_out" : token);
    config.headers.DNT = navigator.doNotTrack;
  } else {
    config.headers = {
      Authorization: "Bearer " + (!token ? "logged_out" : token),
      DNT: navigator.doNotTrack,
    };
  }

  return config;
});

axios.interceptors.response.use(function (config) {
  const cookieString = document.cookie;
  const cookies = cookieString.split(";");

  let token = null;
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith("principally=")) {
      token = cookie.substring(12);
    }
  }

  config.headers.Authorization = "Bearer " + (!token ? "logged_out" : token);
  config.headers.DNT = navigator.doNotTrack;

  return config;
});

axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error?.response?.data?.code === "jwt_error") {
      window.localStorage.setItem(
        "root",
        JSON.stringify("{principally_auth: null, principally_user: null}")
      );
      // window.localStorage.setItem("jwt", JSON.stringify("logged_out"));
      // window.localStorage.setItem("currentUser", JSON.stringify(null));
    }
    return Promise.reject(error);
  }
);

export default axios;
